import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { TextAreaQuestion } from '../../../classes/question-textarea';

@Component({
  selector: 'bepatient-input-textearea',
  templateUrl: './input-textearea.component.html',
  styleUrls: ['./input-textearea.component.scss'],
  standalone: false
})
export class InputTexteareaComponent {
  @Input() question: TextAreaQuestion;
  @Input() parent: UntypedFormGroup;
}
